<template lang="html">
   <div class="test-form">
      <div class="my-5 row justify-content-md-center" style="margin: 0">
         <div class="col-12 col-md-11 col-lg-10 col-xl-9">
            <!-- <Upload accept="image/*" multiple="true" v-model="file"/> -->
            <!-- <Location :model="location" placeholder="Select school's location" v-model="location"/> -->
            <!-- <button class="btn btn-primary" @click="getLocation">Get Location</button> -->

            <!-- <Mobile :value="mobileNum"/>
            <button class="btn btn-primary" @click="changeData">Change Data</button> -->
            
            <!-- <FormTable :table="Product.forms.formTable.forms[0].table" :forms="Product.forms.formTable.forms[0].forms" v-model="tableData"/>
            <button class="btn btn-primary" @click="getLocation">Get Location</button> -->

            <TimePicker type="time" placeholder="Select time"  format="HH:mm" confirm :value="time" :steps="[1,5]"></TimePicker>
            <TimePicker type="timerange" placement="bottom-end" format="HH:mm"  placeholder="Select time" :value="timeRange"></TimePicker>
         </div>
      </div>
   </div>
</template>

<script>
import product from "./resources/stores/product.store";
import {TimePicker} from 'clarks/components/date-picker/index'

export default {
   beforeDestroy () {
      this.$store.unregisterModule('product')
   },
   created(){
      utils.registerModule('product',product,this.$store)
   },
   components:{
      Upload: () => import("clarks/components/upload"),
      Location: () => import("clarks/components/location"),
      FormTable: () => import("clarks/components/form-table"),
      Mobile: () => import("clarks/components/mobile"),
      TimePicker
   },
   computed: {
      ...mapGetters([
         'Product',
         'products'
      ])
   },
   data () {
      return {
         time: '12:30',
         timeRange: ['8:30','12:10'],
         location: {
            address: 'Iganjo',
            location: {
               lat: -8.915995299999999,
               lng: 33.5665566 
            }
         },
         file: '',
         mobileNum: {
            mobile: '0723858532',
            code: {
               callingCode: '93',
               countryCode: 'AF'
            }
         },
         tableData:[
            {
               firstName: 'Martin',
               lastName: 'Shimundulu',
               description: 'This is a sample description',
            }
         ]
      }
   },
   methods: {
      ...mapActions([
         'submitForm',
      ]),
      changeData(){
         this.mobileNum = {
            mobile: '0723858531',
            code: {
               callingCode: '254',
               countryCode: 'KE'
            }
         }
      },
      async clickButton(e){
         if(e.name === 'submit'){
            if(await e.ref.isValid()){
               $notify('success','Valid Form', 'Form is valid',20)
            }
         }
      },
      getLocation(){
         // console.log(this.location.location.lat,this.location.location.lng,this.location.address)
         console.log(this.tableData)
      }
   },
   mounted(){
      utils.registerModule('product',product,this.$store)
   }
}
</script>

<style lang="scss">
   .test-form{
      
   }
</style>